
import { computed } from '@vue/composition-api';
import { useLocalProp } from '@sbvr/lbe-composition-helpers';
import baseComponentFactory from './baseComponentFactory';

export default baseComponentFactory({
  name: 'UISelect',
  props: {
    value: {},
    placeholder: {
      type: String,
    },
  },
  setup (props, { emit }) {
    const internalValue = useLocalProp({ props, emit }, 'value');
    const internalValueWithoutPlaceholder = computed({
      get () {
        if (props.placeholder && (internalValue.value === null || internalValue.value === undefined)) {
          return '__placeholder';
        }
        return internalValue.value;
      },
      set (value: any) {
        if (value !== '__placeholder') internalValue.value = value;
      },
    });
    return {
      internalValueWithoutPlaceholder,
    };
  },
});
